module.exports = __webpack_public_path__ + "img/lib_03.e823bd87.png";